module.exports = __webpack_public_path__ + "img/copy_icon.b620646a.svg";